module.exports = __webpack_public_path__ + "img/03.a27afe8b.jpg";